/** @format */

import { fireAudiogoPixels } from "./src/lib/audiogo";

export const onInitialClientRender = (): void => {
  fireAudiogoPixels(window.location.pathname);
};

export const onRouteUpdate = ({ location }: { location: Location }): void => {
  fireAudiogoPixels(location.pathname);
};
